module.exports = __webpack_public_path__ + "static/img/cod_slip.96ec926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/cod_slip.png
// module id = 5140
// module chunks = 134